import { render, staticRenderFns } from "./TicketsDetailsTransactions.vue?vue&type=template&id=074a3a4e&scoped=true&"
import script from "./TicketsDetailsTransactions.vue?vue&type=script&lang=js&"
export * from "./TicketsDetailsTransactions.vue?vue&type=script&lang=js&"
import style0 from "./TicketsDetailsTransactions.vue?vue&type=style&index=0&id=074a3a4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074a3a4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
